import React, { useState, useEffect } from "react";
import AccountInput from "../../commons/components/accountInput";
import { Col } from "antd";
import Utils from "../../commons/utils/utils";
import PasswordMsg from "../../commons/components/passwordMsg"
import AccountInputValue from "../../commons/components/accountInputValue";

let countNumberIsValid = false;
let lowerCaseLettersIsValid = false;
let upperCaseLettersIsValid = false;
let specialCharLettersIsValid = false;
let hasMininumSizeIsValid = false;
let confirmPasswordIsValid = false;

export default props => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    useEffect( () => {
        if (!props.editing) {
            setNewPassword("");
            setConfirmPassword("");
        }
    }, [props.editing]);

    if (props.editing) {

        return (
            <>
                <Col lg={6} md={15}>
                    <AccountInput
                        name={"password"}
                        type={"password"}
                        label={""}
                        labelText={"Senha atual"}
                        style={{ marginBottom: 16 }}
                        hasError={props.hasErrorCurrentPassword}
                        error={props.errorMsgCurrentPassword}
                        onChange={props.onChangeCurrentPassword} />
                    <AccountInput
                        name={"new_password"}
                        type={"password"}
                        label={""}
                        labelText={"Nova senha"}
                        style={{ marginBottom: 16 }}
                        hasError={props.hasErrorNewPassword}
                        error={props.errorMsgNewPassword}
                        onChange={(e) => { setNewPassword(e.target.value); }} />
                    <AccountInput
                        name={"confirm_password"}
                        type={"password"}
                        label={""}
                        labelText={"Repita a senha"}
                        hasError={props.hasErrorConfirmPassword}
                        error={props.errorMsgConfirmPassword}
                        onChange={(e) => { setConfirmPassword(e.target.value); }} />
                </Col>
            </>
        )
    } else {
        return (
            <Col span={20}>
                <span className={"account-card-data"}>******</span>
            </Col>
        )
    }
}

